import React from 'react';

export default () => (
  <svg preserveAspectRatio="xMidYMid" viewBox="0 0 28 28">
    <path d="M28.001,3.033 L17.016,14.028 L27.795,24.808 L24.799,27.804 L14.021,17.026 L3.050,28.008 L0.011,24.965 L10.980,13.985 L0.203,3.207 L3.199,0.211 L13.975,10.987 L24.962,-0.010 L28.001,3.033 Z" />
  </svg>
);
